import { Box } from "@mui/material";
import { Fragment, ReactNode } from "react";

/** Renders text with basic markdown formatting: **bold**, \n line breaks. */
export function FormattedText({ children }: { children: string }) {
  const lines = children.split("\n");

  return (
    <Box component="span">
      {lines.map((line, lineIdx) => (
        <Fragment key={lineIdx}>
          {lineIdx > 0 && <br />}
          {formatBold(line)}
        </Fragment>
      ))}
    </Box>
  );
}

function formatBold(text: string): ReactNode[] {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <Fragment key={i}>{part}</Fragment>;
  });
}
